import { render } from "./AccessRequest.vue?vue&type=template&id=342e9c10&ts=true"
import script from "./AccessRequest.vue?vue&type=script&lang=ts"
export * from "./AccessRequest.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__